import React, { Fragment, useState, useContext, useEffect } from 'react';
import { UserFilters } from '../../Models/User';

import Heading from '../UI/Heading/Heading';
import Switch from '../UI/Switch/Switch';
import Divider from '../UI/Divider/Divider';
import Text from '../UI/Text/Text';

import style from './Filters.module.scss';
import Icon from '../UI/Icon/Icon';
import Button from '../UI/Button/Button';


const Filters = () => {

    const [filterCount,setFilterCount] = useState<Number>(5);
    const [filters, setFilter] = useState<UserFilters>({
        incidences: true,
        busIncidences: true,
        blocks: true, 
        events: true, 
        renovations: true,
        parking: true,
        bikeStations: true,
        busStops: true
    });

    const setBusIncidences = (busIncidences:boolean) => {
        setFilter({...filters,busIncidences})
    }

    const setEvents = (events:boolean) => {
        setFilter({...filters,events})
    }
    
    const setBusStops = (busStops:boolean) => {
        setFilter({...filters,busStops})
    }

    const setBlocks = (blocks:boolean) => {
        setFilter({...filters,blocks})
    }

    const setBikeStations = (bikeStations:boolean) => {
        setFilter({...filters,bikeStations})
    }

    const setParking = (parking:boolean) => {
        setFilter({...filters,parking})
    }

    const closeAction = () => {
    }

    return <div className={style.Filters}>
        <Heading size="5">
            {/* <Icon name="clock" color="neutral" />  */}
            {filterCount} Filtros | Feed | 17:58
        </Heading>
        <div className={style.Filters__Wrapper}>
            <Text size="m">Se están mostrando {filterCount} capas de contenido</Text>
            <Divider size='normal' />
            <Switch key="fl-event" label="Eventos" color="secondary" labelSize='label-small' notify={setEvents} active={filters.events} /> 
            <Switch key="fl-detour" label="Desvíos de líneas" color="error" labelSize='label-small' notify={setBusIncidences} active={filters.busIncidences} /> 
            <Switch key="fl-stops" label="Paradas de Guaguas" color="primary" labelSize='label-small' notify={setBusStops} active={filters.busStops} /> 
            <Switch key="fl-parking" label="Aparcamiento" color="primary" labelSize='label-small' notify={setParking} active={filters.parking} /> 
            <Switch key="fl-bike" label="Estaciones de Siticleta" color="primary" labelSize='label-small' notify={setBikeStations} active={filters.bikeStations} /> 
            <Switch key="fl-block" label="Cortes y obras" color="primary" labelSize='label-small' notify={setBlocks} active={filters.blocks} /> 
        </div>
    </div>
}

export default Filters;